//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "BowMarker",

    inject: typeof window !== "undefined" ? ["mapbox", "map", "actions"] : [],

    inheritAttrs: false,

    props: {
        coordinates: {
            default: null,
            type: Array,
        },

        index: {
            default: 0,
            type: Number,
        },

        onclick: {
            default: (e) => ({}),
            type: Function,
        },
    },

    data: () => ({
        center: null,
    }),

    created() {
        if (typeof window !== "undefined") {
            this.center = this.map.getCenter();
        }
    },

    methods: {
        async handleMarkerClick(e) {
            if (typeof window !== "undefined") {
                const newCenter = this.onclick(e);

                if (newCenter !== null) {
                    const flyResult = await this.actions.flyTo({
                        center: newCenter,
                    });
                    this.center = flyResult.center;
                }
            }
        },
    },
};
